import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import { useMemo } from "react";

import { twMerge } from "tailwind-merge";

import CustomCard from "components/CustomCard";
import { Loader } from "components/customElements";
import { Tab, Tabs } from "components/Tabs";

import EntityPageEarningsAlertList from "./EntityPageEarningsAlertList";
import styles from "./style.module.scss";

const EntityPageFilingsList = dynamic(
  () =>
    import(
      "components/EntityPageLayout/EntityPageAnnoucements/EntityPageFilingsList"
    ),
  {
    loading: () => (
      <CustomCard className="min-h-screen">
        <Loader />
      </CustomCard>
    ),
  }
);
const EntityPagePresentationsList = dynamic(
  () =>
    import(
      "components/EntityPageLayout/EntityPageAnnoucements/EntityPagePresentationsList"
    ),
  {
    loading: () => (
      <CustomCard className="min-h-screen">
        <Loader />
      </CustomCard>
    ),
  }
);
const EntityPageEventsList = dynamic(
  () =>
    import(
      "components/EntityPageLayout/EntityPageAnnoucements/EntityPageEventsList"
    ),
  {
    loading: () => (
      <CustomCard className="min-h-screen">
        <Loader />
      </CustomCard>
    ),
  }
);

type EntityPageAnnouncementsProps = {};

const EntityPageAnnouncements = ({}: EntityPageAnnouncementsProps) => {
  const router = useRouter();
  const slug = router.query.slug as string;
  const currentTab = router.query.tab;

  const tabContent = useMemo(() => {
    if (currentTab === "presentations") {
      return <EntityPagePresentationsList />;
    }
    if (currentTab === "events") {
      return <EntityPageEventsList />;
    }
    if (currentTab === "earnings-alerts") {
      return <EntityPageEarningsAlertList />;
    }
    return <EntityPageFilingsList />;
  }, [currentTab]);

  return (
    <>
      <Tabs className="pt-0">
        <Tab href={`/entities/${slug}/announcements`} active={!currentTab}>
          Filings
        </Tab>
        <Tab
          href={`/entities/${slug}/announcements?tab=presentations`}
          active={currentTab === "presentations"}
        >
          Presentations
        </Tab>
        <Tab
          href={`/entities/${slug}/announcements?tab=events`}
          active={currentTab === "events"}
        >
          Events
        </Tab>
        <Tab
          href={`/entities/${slug}/announcements?tab=earnings-alerts`}
          active={currentTab === "earnings-alerts"}
          className="pr-[30px] !overflow-hidden min-w-[160px] !max-w-none"
        >
          Earnings/Op Data
          <span
            className={twMerge(
              "bg-ink-pink px-[16px] py-[4px] text-[8px] ml-[5px] text-white absolute top-[2px] right-[-14px] rotate-45"
            )}
          >
            New
          </span>
        </Tab>
      </Tabs>
      <CustomCard
        className={twMerge(
          styles.card,
          "mb-0 md:mb-[30px]",
          "min-h-[max(calc(100vh-500px),720px)]"
        )}
      >
        {tabContent}
      </CustomCard>
    </>
  );
};

export default EntityPageAnnouncements;
